import React from 'react';
import './Hero.css';

export default function Hero() {
  return (
    <section className="hero">
      <picture className="hero-bg-picture">
        <source media="(max-width: 768px)" srcSet="/iltg_hero_bg_mobile.webp" type="image/webp" />
        <img 
          src="/iltg_hero_bg.webp" 
          alt="Playermaker 2.0 Soccer Tracker Background" 
          className="hero-bg-img" 
          fetchpriority="high"
          decoding="async"
          width="1600"
          height="900"
        />
      </picture>
      <div className="hero-container container animate-fade-in">
        <div className="hero-content fullwidth-hero-content">
          <div className="hero-brand-title">PLAYERMAKER 2.0</div>
          <div className="badge-wrapper">
            <span className="badge-volt pulse-glow-volt">NOW IN CANADA</span>
          </div>
          
          <h1 className="hero-title">
            Playermaker 2.0 Smart Soccer Tracker
          </h1>
          <h2 className="hero-subtitle-large">
            TRAIN SMARTER. <span className="text-highlight">PLAY HARDER.</span>
          </h2>
          
          <p className="hero-subtitle">
            Transform your game with Playermaker 2.0, the premier FIFA-approved wearable soccer tracker designed specifically for boot-mounted tracking. Engineered for players, coaches, and academies across Canada, Playermaker measures kick velocity, ball touches, release time, sprint speed, and left vs. right foot balance with pinpoint 1000Hz IMU precision.
          </p>
          
          <div className="hero-actions">
            <a href="#product-showcase" className="btn btn-volt">Shop Playermaker 2.0 &rarr;</a>
            <a href="#how-it-works" className="btn btn-outline">See How It Works &rarr;</a>
          </div>
        </div>
      </div>
    </section>
  );
}
